/**
 * Front-end behavior is managed by the parent Full Slider block.
 */
